import React from 'react';
import PropTypes from 'prop-types';
/**
 * 버튼
 */
const ButtonUnderText = ({ label, value, labelIcon, styleDef, viewStatus, onClickEvt, error,image,styleDiv,styleTxt }) => {
  return (
    <div className="_btn_under_txt_div" style={styleDiv}>
      {viewStatus === '_dim' ? <div className="_dim" /> : ''}
      <div className="_btn_div" onClick={onClickEvt}>
        <div className="_icon" style={styleDef}>
          {
            labelIcon !== "ri-cloud-line" ? <i className={labelIcon} /> : <div>{image}</div> 
          }
        </div>
        <div className="_txt" style={styleTxt}>{label}</div>
      </div>
    </div>
  );
};

ButtonUnderText.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  labelIcon: PropTypes.string,
  image: PropTypes.array,
  styleDef: PropTypes.object,
  styleDiv: PropTypes.object,
  styleTxt: PropTypes.object,
  viewStatus: PropTypes.string,
  onClickEvt: PropTypes.func,
  error: PropTypes.object,
};
ButtonUnderText.defaultProps = {
  label: '',
  value: '',
  image: [],
  labelIcon: 'ri-cloud-line',
  styleDef: {},
  styleDiv: {},
  styleTxt: {},
  viewStatus: '',
  onClickEvt: () => {},
  error: { error: false, msg: '' },
};

export default ButtonUnderText;
